import type { Modal } from "addeus-common-library/stores/modal";
import { useModal } from "addeus-common-library/stores/modal";
import moment from "moment-timezone";
import { defineStore } from "pinia";
import type { ImageModalProps } from "../../components/modal/ImageModal.vue";
import ImageModal from "../../components/modal/ImageModal.vue";
import { useOwner } from "./owner";
import { useRouter } from "vue-router";
import VButton from "addeus-common-library/components/base/button/VButton.vue";
import type { VButtonColor } from "addeus-common-library/components/base/button/VButton.vue";

interface Event {
    [key: string]: (param: NonNullable<unknown>) => void;
}

interface Action {
    component: any;
    content: string;
    props: {
        color: VButtonColor;
    };
    events: Event;
}

interface ModalOption<Props = { [key: string]: any }> {
    title?: string;
    actions?: Action[];
    isCloseDisabled?: boolean;
    props?: Props;
    events?: Event;
    size?: "small" | "medium" | "large";
    onClose?: () => void;
}

export const useMomentaryModal = defineStore("momentaryModal", () => {
    const modal = useModal();
    const router = useRouter();
    const ownerManager = useOwner();

    function isRightOwner(owner: string): boolean {
        const value = ownerManager.ownerID === owner;
        return value;
    }

    function isInTime(date: moment.Moment): boolean {
        const value = moment().isBefore(date, "minute");
        return value;
    }

    function canBeShown(owner: string, maxDate: moment.Moment) {
        return isRightOwner(owner) && isInTime(maxDate);
    }

    async function showImageModal(
        image: string,
        owner: string,
        date: moment.Moment,
    ): Promise<void> {
        console.log(date, date.toISOString());
        const canShow = canBeShown(owner, date);
        if (!canShow) return;
        return new Promise((resolve, reject) => {
            let m: Modal;
            const options: ModalOption<ImageModalProps> = {
                size: "medium",
                title: "",
                props: { src: image },
                actions: [
                    {
                        component: VButton,
                        content: "JE RÉSERVE !",
                        props: {
                            color: "primary",
                        },
                        events: {
                            click() {
                                resolve();
                                m.close();
                                void router.push("/booking");
                            },
                        },
                    },
                ],
                isCloseDisabled: false,
                onClose: reject,
            };
            m = modal.createModal(ImageModal, options);
        });
        // Do the modal stuff
    }

    return {
        showImageModal,
    };
});
